import { styled } from '../../styles';
import { Flex } from '../layout/flex';
export const SpinnerWrapper = styled(Flex)({
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
});
//# sourceMappingURL=spinner_wrapper.js.map